import React, { Component } from 'react';

import cms from '../cms';

class Content extends Component {
  componentDidMount() {
    const { callback } = this.props;
    if (callback) callback();
  }

  createMarkup = () => {
    const { resource } = this.props;
    return { __html: cms[resource] };
  };

  render() {
    const { className, style } = this.props;

    return (
      <div
        className={className}
        style={style}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={this.createMarkup()}
      />
    );
  }
}

// class Content extends Component {
//   state = {
//     text: '',
//   };

//   componentDidMount() {
//     const { resource, callback } = this.props;

//     //    fetch(`${process.env.REACT_APP_CMS_API}/Cms?resource=${resource}`)
//     fetch(`${process.env.REACT_APP_CMS_API}/${resource}.html`)
//       .then(response => response.text())
//       .then(data => {
//         this.setState({ text: data }, () => {
//           if (callback) callback();
//         });
//       })
//       .catch(error => {
//         this.setState({ text: error });
//       });
//   }

//   createMarkup = () => {
//     const { text } = this.state;
//     return { __html: text };
//   };

//   render() {
//     const { className, style } = this.props;

//     return (
//       <div
//         className={className}
//         style={style}
//         // eslint-disable-next-line react/no-danger
//         dangerouslySetInnerHTML={this.createMarkup()}
//       />
//     );
//   }
// }

export default Content;
